const reload = (debug?: string) => {
  return () => {
    if (debug) {
      console.log(debug);
    }

    window.location.reload();
  };
};

function useReload(debug?: string) {
  return reload(debug);
}

export default useReload;
